import { apiSauceInstance } from 'src/services/api'
import { ProdutosRodoparResponse } from '../types'

export const produtosRodopar = async () => {
  return apiSauceInstance.post<
    ProdutosRodoparResponse & { message: string; error: any }
  >('/produtos/synchronize-rodopar')
}
